<template>
  <v-flex xs12 md10 xl8>
    <ffec-reconciliation-drilldown
      v-if="modalVisible"
      :fs-year="this.parameters.fsYear"
      :quarter="this.quarter"
      :divisions="this.parameters.divisions"
      :divisionsList="this.parameters.divisionsList"
      :ccyPairId="this.ccyPairId"
      :rowNumber="this.rowNumber"
      :ffec-drill-down-column="this.ffecDrillDownColumn"
      @close="closeModal"
    />
    <page-toolbar>
      <summary-toolbar @change="onChange" :report-type="reportType" v-slot="slotProps">
        <div v-show="ccyPairId != -1">
          <kendo-numerictextbox
            v-model="arTransferAmount"
            style="width:132px"
            :disabled="isReadOnly"
            :decimals="2"
            :round="true"
            :spinners="false"
          /><kendo-button
            type="button"
            title="Save AR Transfer"
            v-if="!isReadOnly"
            @click="saveArTransfer"
            ><i class="k-icon k-i-save"></i>
          </kendo-button>
          <kendo-button type="button" title="Export to Excel" @click="exportToExcel">
            <i class="k-icon k-i-excel"></i>
          </kendo-button>
        </div>
      </summary-toolbar>
    </page-toolbar>
    <kendo-grid
      height="calc(100vh - 170px)"
      ref="ffecReconciliationGrid"
      v-on:databound="onGridDataBound"
      :data-source="this.dataSource"
      :filterable="false"
      :sortable="false"
      :pageable="false"
      :columns="columns"
      :detailInit="detailInit"
    ></kendo-grid>
  </v-flex>
</template>
<script>
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import SummaryToolbar from '@/components/Report/SummaryToolbar'
import {getDataItem} from '@/helpers/kendo-helpers'
import FfecReconciliationDrilldown from '@/components/Clients/Heroux/FfecReconciliationDrilldown'
import axios from 'axios'
import notification from '@/helpers/notification'
import security from '@/mixins/security'

export default {
  name: 'FfecReconciliation',
  mixins: [security],
  components: {
    PageToolbar,
    SummaryToolbar,
    FfecReconciliationDrilldown,
  },
  mounted() {
    let vm = this
    let grid = vm.$refs.ffecReconciliationGrid.kendoWidget()

    grid.element.on('click', '.ffecColumnDrillDown', e => {
      const dataItem = getDataItem(e.target)
      vm.quarter = dataItem.quarterId
      vm.ccyPairId = dataItem.ccyPairId
      vm.rowNumber = dataItem.rowNumber
      vm.ffecDrillDownColumn = 1
      vm.modalVisible = true
    })

    grid.element.on('click', '.fvBeginningColumnDrillDown', e => {
      const dataItem = getDataItem(e.target)
      vm.quarter = dataItem.quarterId
      vm.ccyPairId = dataItem.ccyPairId
      vm.rowNumber = dataItem.rowNumber
      vm.ffecDrillDownColumn = 2
      vm.modalVisible = true
    })

    grid.element.on('click', '.fvEndColumnDrillDown', e => {
      const dataItem = getDataItem(e.target)
      vm.quarter = dataItem.quarterId
      vm.ccyPairId = dataItem.ccyPairId
      vm.rowNumber = dataItem.rowNumber
      vm.ffecDrillDownColumn = 3
      vm.modalVisible = true
    })
  },
  methods: {
    closeModal() {
      this.modalVisible = false
      this.quarter = null
      this.ccyPairId = -1
      this.rowNumber = null
      this.ffecDrillDownColumn = null
    },
    onGridDataBound(e) {
      var gridData = e.sender.dataSource.view()
      var grid = this.$refs.ffecReconciliationGrid.kendoWidget()
      gridData.forEach(dataItem => {
        var row = grid.table.find("tr[data-uid='" + dataItem.uid + "']")
        if (this.ccyPairId !== -1) {
          row.find('.k-hierarchy-cell').html('')
        }

        const rowId = dataItem.rowId
        if (dataItem.rowType == 'blue') {
          row.addClass('blueRow')
        } else {
          if (dataItem.rowType == 'bold') {
            row.addClass('boldRow')
          }
        }

        if (rowId == 1 || rowId == 2 || rowId == 3) {
          row.find('.ffecColumnDrillDown').removeClass('ffecColumnDrillDown')
          row.find('.fvEndColumnDrillDown').removeClass('fvEndColumnDrillDown')
          row.find('.fvBeginningColumnDrillDown').removeClass('fvBeginningColumnDrillDown')
        }
        if (rowId == 9) {
          row.find('.fvBeginningColumnDrillDown').removeClass('fvBeginningColumnDrillDown')
          row.find('.fvEndColumnDrillDown').removeClass('fvEndColumnDrillDown')
        }
      })
    },
    onChange(e) {
      this.parameters = e
      this.ccyPairId = this.parameters.ccyPairId
      this.getArTransferAmount().then(data => {
        this.arTransferAmount = Number(data.arTransferAmount)
      })

      var grid = this.$refs.ffecReconciliationGrid.kendoWidget()
      grid.dataSource.read()
    },
    exportToExcel() {
      const exportUrl = '/api/heroux/FfecReconciliationReport/exportToExcel'
      location.href = `${exportUrl}?clientId=${this.clientId}&fsYear=${
        this.parameters.fsYear
      }&quarter=${this.parameters.quarter}&divisions=${this.parameters.divisions}&t=${
        this.tokenString
      }`
    },
    saveArTransfer() {
      axios
        .post('/api/heroux/ffecReconciliationReport/updateArTransferAmount', {
          fsYear: this.parameters.fsYear,
          amount: Number(this.arTransferAmount),
          ccyPairId: this.parameters.ccyPairId,
        })
        .then(response => {
          if (response.status == 200) {
            notification('Ar Transfer saved.')
            var grid = this.$refs.ffecReconciliationGrid.kendoWidget()
            grid.dataSource.read()
          }
        })
        .catch(() => notification('Some error', 'error'))
    },
    async getArTransferAmount() {
      const fsYear = this.parameters.fsYear
      const ccyPairId = this.parameters.ccyPairId
      const {data} = await axios.get('/api/heroux/ffecReconciliationReport/getArTransferAmount', {
        params: {fsYear, ccyPairId},
      })
      return data
    },
    detailInit(e) {
      const $container = kendo.jQuery("<div id='detailGrid'/>")
      kendo.ui.progress($container, true)
      const rowId = e.data.rowId
      const columns = this.columns

      $container.appendTo(e.detailCell).kendoGrid({
        columns: columns,
        dataBound: () => kendo.ui.progress($container, false),
        dataSource: {
          type: 'aspnetmvc-ajax',
          schema: {
            errors: 'errors',
            total: 'total',
            data: 'data',
          },
          transport: {
            read: {
              type: 'GET',
              url: '/api/heroux/FfecReconciliationReport/getData',
              data: () => ({
                clientId: this.clientId,
                fsYear: this.parameters.fsYear,
                quarter: this.parameters.quarter,
                divisions: this.parameters.divisions,
                ccyPairId: this.parameters.ccyPairId,
                rowId: rowId,
              }),
              dataType: 'json',
            },
          },
        },
      })
    },
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    columns() {
      return [
        {
          field: 'rowDescription',
          title: 'Description',
          width: 230,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'ccyPair',
          title: 'Ccy Pair',
          width: 80,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'ffec',
          title: 'FFEC',
          width: 82,
          attributes: {style: 'text-align: right;', class: 'ffecColumnDrillDown'},
          format: this.numericFormat,
        },
        {
          field: 'averageRate',
          title: 'Average Rate',
          width: 82,
          attributes: {style: 'text-align: right;'},
          format: this.rateFormat,
        },
        {
          field: 'fairValueAtPeriodBeginning',
          title: 'Fair Value At Period Beginning',
          width: 82,
          attributes: {style: 'text-align: right;', class: 'fvBeginningColumnDrillDown'},
          format: this.numericFormat,
        },
        {
          field: 'fairValueAsAtPeriodEnd',
          title: 'Fair Value as at Period End',
          width: 82,
          attributes: {style: 'text-align: right;', class: 'fvEndColumnDrillDown'},
          format: this.numericFormat,
        },
        {
          field: 'fairValueVariation',
          title: 'Fair Value Variation',
          width: 82,
          attributes: {style: 'text-align: right;'},
          format: this.numericFormat,
        },
        {
          field: 'fairValueVariationTaxes',
          title: 'Fair Value Variation - Net of taxes',
          width: 82,
          attributes: {style: 'text-align: right;'},
          format: this.numericFormat,
        },
        {
          field: 'taxes',
          title: 'Taxes',
          width: 82,
          attributes: {style: 'text-align: right;'},
          format: this.numericFormat,
        },
      ]
    },
  },
  data() {
    return {
      arTransferAmount: 0,
      modalVisible: false,
      reportType: 1,
      quarter: null,
      ccyPairId: -1,
      rowNumber: null,
      ffecDrillDownColumn: null,
      rateFormat: '{0: #.####;(#.####);-}',
      numericFormat: '{0: #,;(#,);-}',
      parameters: {},
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/heroux/FfecReconciliationReport/getData',
            data: () => ({
              clientId: this.clientId,
              fsYear: this.parameters.fsYear,
              quarter: this.parameters.quarter,
              divisions: this.parameters.divisions,
              ccyPairId: this.parameters.ccyPairId,
            }),
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'rowId',
            fields: {
              rowId: {type: 'number'},
              fsYear: {type: 'number'},
              quarterId: {type: 'number'},
              rowDescription: {type: 'string'},
              ccyPair: {type: 'string'},
              rowType: {type: 'string'},
              rowNumber: {type: 'number'},
              ffec: {type: 'number'},
              averageRate: {type: 'number'},
              fairValueAtPeriodBeginning: {type: 'number'},
              fairValueAsAtPeriodEnd: {type: 'number'},
              fairValueVariation: {type: 'number'},
              fairValueVariationTaxes: {type: 'number'},
              taxes: {type: 'number'},
              ccyPairId: {type: 'number'},
            },
          },
        },
      }),
    }
  },
}
</script>
